import React from 'react';
import { StyledImage, StyledWrapper } from './style';
import weAreModule from '../../../../assets/images/png/somos3_0.png';
// import { API_SOCIAL } from '../../../constants/api';
// import request from '../../../utils/api';

// let image = '';

// const getImageURL = params =>
//   request(`${API_SOCIAL}widget/home`, {
//     params,
//     method: 'GET'
//   }).then(response => {
//     response.map(el => {
//       if (el.type === 'md3') {
//         image = el.icon;
//       }
//       return image;
//     });
//   });
//
// getImageURL();
const WeAreModule = () => (
  <StyledWrapper>
    <StyledImage src={weAreModule} />
  </StyledWrapper>
);

export default WeAreModule;
